export * from "./pricing";

export const LANGUAGES_CODES = {
	ENGLISH: "en_US",
	GERMAN: "de_DE",
	DEBUG: "translation_debug",
};

export const TAB_SET_STYLE = {
	padding: "7px",
	"border-bottom-color": "rgba(0,150,188,255)",
	display: "grid",
	width: "400px",
};

export const ROUTES = {
	CHECKOUT: "checkout",
	LOG_IN: "/auth?tab=login",
	SIGN_UP: "/auth?tab=signup",
	INVITATION: "invitation",
	ROOT: "",
	WILDCARD: "**",
	DASHBOARD: "dashboard",
	LOGIN: "login",
	SIGNUP: "signup",
	FORGOT_PASSWORD: "forgot-password",
	RESET_PASSWORD: "reset-password",
	ACCOUNT_ACTIVATION: "account-activation",
	BUYER: "buyer",
	SUPPLIER: "supplier",
	PUBLIC: "public",
	ROADMAP: "roadmap",
	MAINTENANCE: "maintenance",
	UNSUBSCRIBE: "unsubscribe",
	BUYER_ROUTE: "/buyer",
	CART_ROUTE: "/cart",
	SUPPLIER_ROUTE: "/supplier",
	AUTH: "auth",
	ORG_SETTINGS: "org-settings",
	ORG_SETTINGS_GENERAL: "org-settings/general",
	ORG_SETTINGS_ADDRESSES: "org-settings/addresses",
	PROFILE_SETTINGS: "profile-settings",
	ORG_SETTINGS_ROUTE: "/org-settings",
	OVERVIEW: "overview",
	DETAILS: "details",
	ANALYTICS: "analytics",
	TENDERS: "tenders",
	ORDERS: "orders",
	CONTRACTS: "contracts",
	OFFERS: "offers",
	NEW_TENDER: "new-tender",
	NEW_QUOTATION: "new-quotation",
	NEW_QUOTATION_ROUTE: "/new-quotation",
	NEW_TENDER_ROUTE: "/new-tender",
	FORGOT_PASSWORD_ROUTE: "auth/forgot-password",
	TENDER_PRODUCT_DETAILS: "details",
	TENDER_PRODUCT_DETAILS_ROUTE: "/details",
	TENDER_PRODUCT_ROUTE: "/products",
	SUPPLIER_TENDERS_ROUTE: "/tenders",
	TENDERS_ROUTE: "/tenders",
	PRODUCTS: "products",
	CART: "cart",
	BUYER_ORDER_ROUTES: "/buyer/orders",
	ORDER_DETAILS_ROUTE: "/orders/details",
	CONTRACT_DETAILS_ROUTE: "/contracts/details",
	ORDER_DETAILS: "details",
	SHOP: "shop",
	SHOP_ROUTE: "/shop",
	CREATE_ORDER_ROUTE: "/create-order",
	CREATE_ORDER: "create-order",
	CONTRACTS_DETAILS: "details",
	PRODUCT_DETAILS: "product-details",
	SUBSCRIPTIONS_ROUTE: "/subscriptions",
	SUBSCRIPTIONS_ACTIVE: "/subscriptions/active",
	SUBSCRIPTIONS_AVAILABLE: "/subscriptions/available",
	SUBSCRIPTIONS_CREATE: "/subscriptions/create",
	SUBSCRIPTIONS_SEARCH: "/subscriptions/search"
};

export const ERRORS = {
	FAILED_REGISTER: "User failed to Register",
	FAILED_LOGIN: "User Login Failed",
	FAILED_REQUEST_PASSWORD_RESET: "Sending Request for Password Reset Failed",
	FAILED_ACTIVATE_ACCOUNT: "Sending Account Activation Failed",
	FAILED_SET_NEW_PASSWORD_AFTER_PASSWORD_REQUEST:
		"Setting new Password after Reset Failed",
	INVITATION: {
		NEW_USER: "New User try to accept Invitation to Org",
		EXISTING_USER: "Existing User try to accept Invitation to Org",
	},
};

export const NOTIFICATION_SETTINGS = {
	nzDuration: 3000,
	nzPauseOnHover: true,
	nzStyle: {
		padding: "25px",
	},
};

export const GLOBAL_NZCONFIG = {
	icon: {
		nzTwotoneColor: "#2496be",
	},
};

export const API_ENDPOINTS = {
	LOGIN_ADMIN: "/platform/login",
	LOGIN: "/login",
	LOGOUT: "/logout",
	REGISTER: "/register",
	FORGOT_PASSWORD: "/forgot/password",
	RESET_PASSWORD: "/forgot/password/reset",
	ACTIVATE: "/activate",
	ACTIVATION_LINK: "/send/activation-link",
	VERIFY_TOKEN: "/verify/token",
	VERIFY_VALIDATION: "/verify/validation-code",
	REFRESH_TOKEN: "/refresh/token",
	VERIFY_LINK: "/event-link/validate"
};

export const ROUTE_PREFIX = {
	ADMIN: "/a",
	SUPPLIER: "/s",
	BUYER: "/b",
	PUBLIC: "/api/v1",
};

export const ERROR_KEYS = {
	REQUIRE: {
		EMAIL: "require_email",
		ORGANIZATION: "require_organization",
		PASSWORD: "require_password",
		USERNAME: "require_username",
		CONFIRM_PASSWORD: "require_confirm_password",
		NEW_OR_EDIT_ADDRESS: "new_or_edit_address",
		DEADLINE: "deadline_required",
		CUSTOMREASON: "require_custom_reason",
		FIRST_NAME: "require_first_name",
		LAST_NAME: "require_last_name",
	},
	INVALID: {
		EMAIL: "invalid_email",
		DIGITS_NOT_ALLOWED: "digits_not_allowed",
		ONLY_DIGITS_ALLOWED: "only_digits_allowed",
		PASSWORD: "invalid_password",
		ORGANIZATION: "invalid_organization",
		FIRST_NAME: "invalid_first_name",
		LAST_NAME: "invalid_last_name",
		SPECIAL_CHARACTER_REQUIRED: "special_character_required",
		INVALID_SPECIAL_CHARACTER: "invalid_special_character",
		DIGIT_REQUIRED: "digit_required",
		UPPERCASE_LETTER_REQUIRED: "uppercase_character_required",
		LOWERCASE_LETTER_REQUIRED: "lowercase_character_required",
		SPACE: "invalid_space",
		DEADLINE: "deadline_invalid",
		WEBSITE: "invalid_website",
		ACTIVATE_TENDER_ON: "activate_tender_date_invalid",
		SIGN_UP_PASSWORD:'sign_up_invalid_password',
		PASSWORD_NOT_MATCH:'no_match'

	},
	MIN_LENGTH: {
		GENERIC: "minlength_generic",
		PASSWORD: "short_password",
		ZIP_CODE: "short_zip_code",
		ORGANIZATION_NAME: "short_org_name",
		SIGN_UP_PASSWORD: 'short_password'
	},
	MAX_LENGTH: {
		GENERIC: "maxlength_generic",
		ZIP_CODE: "long_zip_code",
		DESCRIPTION: "long_description",
	},
	INCORRECT: {
		CONFIRM_PASSWORD: "password_not_matched",
		EMAIL: "incomplete_email",
		DEADLINE: "deadline_incorrect",
		ACTIVATE_TENDER_ON: "activate_tender_date_incorrect"
	},
	MIN_VALUE: {
		PRICE: "higher_value_required",
	},
};

export const SETTINGS_ROUTES = [
	"general",
	"addresses",
	"users",
	"categories",
	"roles",
	"sub-organizations",
	"danger-zone",
	"api-keys",
	"user-roles",
	"ratings"
];

export const MAX_DESCRIPTION_LENGTH = 2500;

export const ADDRESS_TABLE_COLUMN_WIDTH = {
	ACTION: "200px",
	ROLES: "150px",
	INDEX: "70px",
};

export const ACTIVE_ORDERS_TABLE = {
	ACTION: "150px",
	SUPPLIER: "30%",
	DELIVERY_DATE: "15%",
	ORDER_ID: "20%",
};

export const ADDRESS_MODAL_STYLE = {
	top: "50px",
};

export const INVITE_MODAL_STYLE = {
	width: "50%",
};

export const CREATE_ROLE_MODAL_STYLE = {
	width: "60%",
};

export const CREATE_SUB_ORGANISATION_MODAL_STYLE = {
	width: "65%",
};

export const BREADCRUMB = {
	HOME: "home",
	OVERVIEW: "dashboard",
	TENDERS: "tenders",
	NEW_TENDER: "new_tender",
	NEW_QUOTATION: "new_quotation",
	TENDER_ID: "tender_id",
	CONTRACTS: "contracts",
	ORDERS: "orders",
	PRODUCTS: "products",
	PRODUCT_DETAILS: "product_details",
	CART: "cart",
	CHECKOUT: "checkout",
	SHOP: "shop",
	DETAILS: "details",
	USER_SETTINGS: "settings_user",
	ORG_SETTINGS: "settings_organisation",
	ANALYTICS: "analytics",
	OFFERS: "offers",
};

export const INPUT_TYPE = {
	NUMBER: "number",
};

export const USER_TYPE = {
	BUYER: "buyer",
	SUPPLIER: "supplier",
};

export const MODAL_TITLE = {
	ADD_PRODUCT: "Add a product",
	FAVORITE_PRODUCTS: "Your favorite products",
	LAST_USED_PRODUCTS: "Your last used products",
};

export const TABLE_TYPE = {
	NORMAL: "normal",
	ADD_PRODUCT: "addProduct",
};

export const PRODUCT_FORM_MODAL_STYLE = {
	width: "90%",
	overview: "auto",
};

export const WELCOME_SCREEN_MODAL_STYLE = {
	width: "40%",
	overview: "auto",
};

export const DOWNLOAD_DROPDOWN_STYLE = {
	width: "130px",
	"text-wrap": "auto",
};

export const CHECKBOX_COLUMN_STYLE = {
	width: "100px",
};

export const VALIDATION_MESSAGE = {
	SPECIAL_CHARACTERS: ".,!?^'\"*@#%&$(){/[]}+=~<>:;-",
};

export const REGEX = {
	ONLY_LETTERS: /^[a-zA-ZäöüÄÖÜß\s]*$/,
	DIGITS: /[0-9]/,
	NAME: /[^a-zA-ZäöüÄÖÜß ]/g,
	PASSWORD:
		/^(?=.*?[A-ZÄÖÜß])(?=.*[.,!?^'"*@#%`´&§ß$(){/[\]\\}+=~_<>:;-])(?=.*?[0-9])((?=.*?[a-zäöü]))([^\s]){8,}$/,
	EMAIL: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
	SPECIAL_CHARACTERS: /[ `!@#$§´%^&_*()+\-=\[\]{};':"\\|,.<>\/?~]/,
	SPECIAL_CHARACTERS_WITHOUT_SPACE_HYPHEN:
		/[`!@#$%^&*()_+\=\[\]{};':"\\|,.<>\/?~]/,
	UPPERCASE_LETTERS: /[A-ZÄÖÜß]/,
	LOWERCASE_LETTERS: /[a-zäöü]/,
	SPACES: /(\s)/g,
	ONLY_EAN: {
		$regex: "^((?!NOEAN).)",
		$options: "i",
	},
	UNPAID: {
		$regex: "^((?!PAID).)",
		$options: "i",
	},
	WEBSITE: /^https?:\/\/([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(\/.*)?$/,
	USERNAME: /^[a-zA-ZäöüÄÖÜß\s]+(?:[-\s][a-zA-ZäöüÄÖÜß]+)*$/g,
};

export const URL = {
	ENGLISH: {
		TAC: "https://www.tenderpilot.com/generalterms/",
		PRIVACY_POLICY: "https://www.tenderpilot.com/privacy-policy/",
	},
	GERMAN: {
		TAC: "https://www.tenderpilot.de/agb/",
		PRIVACY_POLICY: "https://www.tenderpilot.de/datenschutz/",
	},
};

export const URL_PARAMS = {
	EMAIL: "email",
	CODE: "code",
	TYPE: "type",
};

export const ACTIVATION_ERRORS = {
	ALREADY_ACTIVATED: "__user_already_activated__",
	ALREADY_ADDED: "__user_already_added__",
};

export const UNAUTHORIZE_ERRORS = {
	UNAUTHORIZE: "Unauthorized",
};

export const SIGN_UP_ERRORS = {
	EMAIL_IN_USE: "__email_inuse__",
	ORGANIZATION_IN_USE: "__organization_inuse__",
	USER_NOT_ACTIVATED: "__user_not_activated__",
	CODE_DOES_NOT_EXIST: "__code_does_not_exist__",
	INVALID_CODE: "__invalid_code__",
	INACTIVE_CODE: "__code_inactive__",
	CODE_EXPIRED: "__code_expired__",
	CODE_NOT_VALID_FOR_BUYERS: "__code_not_valid_for_buyers__"

};


export const LOGOUT_ERRORS = {
	TOKEN_TEMPERED: "__token_tampered__",
	TOKEN_EXPIRED: "__token_expired__",
};

export const QUOTATION_SUCCESS_KEYWORDS = {
	QUOTATION_CREATED: "__quotations_created__",
	QUOTATION_UPDATED: "__quotations_updated__"
}

export const QUOTATION_ERRORS = {
	QUOTATION_ALREADY_CREATED: "__quotation_already_created__",
	INVALID_PRODUCTS: "__invalid_products__",
	TENDER_EXPIRED: "__tender_deadline_expired__",
};

export const CONTRACT_ERRORS = {
	CONTRACT_NOT_FOUND: "__contract_not_found__",
	INVALID_CONTRACT: "__invalid_contract__",
	INVALID_CONTRACT_PRODUCT: "__invalid_contract_product__",
	VOLUME_EXCEEDS: "__product_volume_exceeds_order_volume_for_contract__",
};

export const ORGANIZATION_ERRORS = {
	ORGANIZATION_NOT_FOUND: "__organization_not_found__",
	USER_NOT_IN_ORGANIZATION: "__user_not_in_organization__",
};

export const NOTIFICATION_KEYWORDS = {
	ACCOUNT_ACTIVATED: "account_activated",
	ACCOUNT_NOT_ACTIVATED: "account_not_activated",
	RESEND_ACCOUNT_ACTIVATION: "resend_account_activation",
	FORGOT_PASSWORD: "forgot_password",
	RESET_PASSWORD: "reset_password",
	SIGN_UP: "sign_up",
	ALREADY_ACTIVATED: "already_activated",
	ACCOUNT_ACTIVATION: "account_activation",
	ACCOUNT_ACTIVATION_LINK: "account_activation_link",
	EMAIL_ALREADY_EXISTS: "email_already_exists",
	ORGANISATION_ALREADY_EXISTS: "organisation_already_exists",
	PRODUCT_FILE_UPLOAD: "file_upload",
	PRODUCT_FILE_UPLOAD_IN_PROGRESS: "product_import_already_in_progress",
	MAXIMUM_IMPORT_EXCEEDED: "maximum_import_per_day_exceeded",
	MAXIMUM_PRODUCTS_EXCEEDED: "maximum_products_limit_exceeded",
	PRODUCTS_IMPORT_LIMIT_EXCEEDED: "__products_import_limit_exceeds__",
	QUOTATION_ALREADY_CREATED: "quotation_already_created",
	TENDER_UPDATED: "tender_updated",
	TENDER_CREATED: "__tenders_created__",
	TENDER_PUBLISHED: "__tender_published__",
	TENDER_STATUS_UPDATED: "__tender_updated__",
	TENDER_ALREADY_REJECTED: "__tender_already_rejected__",
	TENDER_REMOVED: "__tenders_removed__",
	DATE_FORMATE: "date_formate",
	DATE_GRATER: "date_grater",
	INVITATION_ACCEPT: "invitation_accept",
	ALREADY_ACCEPTED: "already_accepted",
	UNAUTHORIZE: "user_unauthorized",
	QUOTATION_NOT_CREATED: "quotation_not_created",
	INVALID_PRODUCT: "invalid_product",
	CONTRACT_NOT_FOUND: "contract_not_found",
	INVALID_CONTRACT: "invalid_contract",
	INVALID_CONTRACT_PRODUCT: "invalid_contract_product",
	EXCEED_VOLUME: "exceed_volume",
	QUOTATION_UPDATED: "quotation_updated",
	FILES_MISSING: "files_missing",
	TRY_AGAIN: "try_again",
	TENDER_EXPIRED: "tender_expired",
	SELECT_ONE_PRODUCT: "select_one_product",
	PRODUCT_FETCH: "product_fetch",
	ROLE_CHANGED: "role_changed",
	ORGANIZATION_NOT_FOUND: "organization_not_found",
	USER_NOT_IN_ORGANIZATION: "user_not_in_organization",
	CATEGORIES_SELECTED: "categories_selected",
	CATEGORIES_REMOVED: "categories_removed",
	ORDER_CANCELLED: "__order_cancelled__",
	INVALID_TYPE: "__invalid_file_type__",
	INVALID_SIZE: "__invalid_file_size__",
	INVALID_ATTACHMENT_TYPE: "_invalid_file_type_",
	INVALID_ATTACHMENT_SIZE: "_invalid_file_size_",
	INVALID_ADRRESS: "__invalid_addresses__",
	DATE_GREATER: "date.greater",
	SOMETHING_WENT_WRONG: "something_went_wrong",
	PRODUCT_PRICE_REQUESTED: "__product_price_requested__",
	PRODUCT_PRICE_ALREADY_REQUESTED: "__product_price_already_requested__",
	PRODUCT_UPDATED: "__product_updated__",
	PRODUCT_PRICE_ALREADY_UPDATED: "__product_price_already_updated__",
	UNSUBSCRIBED_TENDER: "unsubscribed_tender",
	SUBSCRIBED_TENDER: "subscribed_tender",
	ORGANIZATION_EXISTS: "__organization_exists__",
	NO_ORGANIZATION_FOUND: "__organization_not_found__",
	INVALID_TENDER_PRODUCTS: "__invalid_tender_products__",
	CATEGORY_NOT_FOUND: "__category_not_found__",
	CATEGORY_NOT_MATCHED: "__category_not_matched__",
	INVALID_ADDRESS: "__invalid_tender_addresses__",
	USER_NOT_FOUND: "__users_not_found__",
	VALIDATE_FILE_AGAIN: "__validate_file_again__",
	INVALID_TENDER_REQUEST: "__invalid_tender_request__",
	NO_SUBSCRIPTION: "__subscription_not_found__",
	SUBSCRIPTION_EXPIRED : "__subscription_expired__",
	ADDITIONAL_INFORMATION_ADDED : "__tender_additional_information_added__",
	ORGANIZATION_UPDATED: "_organization_updated_",
	CATEGORY_LIMIT: "_category_limit",
	DELETE_CATEGORY: "_delete_category",
	INVITE_TENDER: "_invite_tender_",
	PRODUCT_VOLUME: "_product_volume_"
};

export const ORDER_CANCELLATION_ERROR = {
	ORDER_ALREADY_CANCELLED: "__order_has_been_already_cancelled__",
	ORDER_ALREADY_SHIPPED: "__order_has_been_already_shipped__",
	ENTER_CUSTOM_REASON: "__enter_custom_reason__",
};

export const MESSAGE_KEYWORDS = {
	CART_UPDATED: "cart_updated",
};

export const PRODUCT_ERROR = {
	ALREADY_EXISTS: "__product_already_exists__",
	ZERO_PRICE: "price can not be 0",
};

export const COMMENT_ERROR = {
	ATTACHMENT_IN_PROCESS: "__attachment_in_process__",
	ATTACHMENT_NOT_FOUND: "__attachment_not_found__"
};

export const TENDER_ERROR = {
	ATTACHMENT_NOT_FOUND: "__attachment_not_found__",
	ATTACHMENT_DELETED: "__attachment_not_found_or_deleted__",
	ATTACHMENT_IN_PROCESS: "__attachment_in_process__",
	ATTACHMENT_UPLOAD_FAILED: "__attachment_status_failed__"
};

export const LOCAL_STORAGE = {
	TOKEN: "token",
	LANGUAGE: "language",
	CART: "cart",
	DELIVERY_ADDRESS: "deladdr",
	DELIVERY_DATE: "deldate",
	INVOICE_ADDRESS: "invaddr",
	INVOICE_EMAIL: "inveml",
	DELIVERY_OPTION: "delopt",
	TENDER: "tender"
};

export const SESSION_STORAGE = {
	TENDER: "tender",
	CART: "cart",
	STATUS: "status",
	TENDER_STATUS: "tender_status",
	SUPPLIER_TENDER: "supplier_tender",
};

export const QUOTATION_ATTACHMENT_MODAL_STYLE = {
	width: "80%",
};

export const TENDER_PRODUCT_ATTACHMENT_MODAL_STYLE = {
	width: "80%",
};

export const ALTERNATIVE_ACCEPT_MODAL_STYLE = {
	width: "80%",
};

export const ALTERNATIVE_PRODUCT_MODAL_STYLE = {
	width: "40%",
};

export const CREATE_PRODUCT_MODAL_STYLE = {
	top: "40px",
	width: "40%",
	"max-width": "600px",
	"min-width": "300px",
	overflow: "auto",
};

export const IMPORT_ERROR_MODAL_STYLE = {
	width: "60%",
	"max-width": "600px",
	"min-width": "300px",
	overflow: "auto",
};

export const PRODUCT_IMPORT_MODAL_STYLE = {
	width: "70%",
	"min-width": "350px",
	"max-width": "900px",
	overflow: "auto",
};

export const ADDED_PRODUCT_MODAL_STYLE = {
	width: "70%",
	overflow: "auto",
};

export const AUTH_FORM_DROP_DOWN_STYLE = {
	width: "calc(100% + 42px)",
	left: "-30px",
	"text-align": "center",
	"margin-top": "8px",
};

export const CATEGORY_SELECT_STYLE = {
	width: "300px",
	"text-align": "center",
};

export const INFO_TABLE_COLUMN_SPAN = {
	BUYER: {
		first: "4",
		second: "16",
		last: "4",
	},
	FINAL_CHECK: {
		first: "6",
		second: "12",
		last: "6",
	},
	Tender_INFO: {
		first: "0",
		second: "16",
		last: "8",
	},
	ORDER_INFORMATION: {
		first: "6",
		second: "12",
		last: "6",
	},
	QUOTATION_PAYMENT: {
		first: "7",
		second: "10",
		last: "7",
	},
};

export const CHECKBOX_COLUMN_WIDTH = "150px";

export const PRODUCTS_DROP_DOWN_STYLE = {
	width: "130px",
};

export const API_KEY_MODAL_STYLE = {
	width: "40%",
	"max-width": "600px",
	overflow: "auto",
};

export const TENDER_MODAL_STYLE = {
	width: "40%",
	"min-width": "300px",
	overflow: "auto",
};

export const TENDER_REJECT_MODAL_STYLE = {
	height: "350px",
};

export const ORDER_ABORT_MODAL_STYLE = {
	height: "270px",
};

export const ORDER_DECLINE_MODAL_STYLE = {
	height: "250px",
};

export const TABS = {
	PRODUCTS: "?tab=products",
	MY_PRODUCTS: "my-products",
};

export const PRIVATE_TENDER_INFO_UPDATE_MODAL_STYLE = {
	width: "70%",
	overflow: "auto",
};

export const BUYER_TENDER_MODAL_STYLE = {
	BODY_STYLE: {
		height: "85vh", overflow: "auto",
	},
	STYLE: {
		width: "95%"
	}
};

export const PAGINATION = {
	DEFAULT: 10,
	BUYER_PRODUCTS: 10,
	BUYER_TENDERS: 10,
	BUYER_DRAFT_TENDERS: 5,
	BUYER_TENDER_PRODUCTS: 10,
	IMPORT_PRODUCTS: 10,
	SUPPLIER_PRODUCTS: 10,
	SUPPLIER_TENDERS: 10,
	BUYER_ADDRESS: 10,
	BUYER_ORDERS: 10,
	CATEGORY: 5,
	CONTRACT_SUPPLIERS_SHOP: 5,
};

export const SUPPLIER_PRODUCT_VISIBILITY = {
	VISIBLE: 1,
	HIDE: 0,
};

export const TAX = {
	DEFAULT: 19,
};

export const REQUEST_TYPE = {
	GET: "get",
	DELETE: "delete",
	POST: "post",
};

export const APP_LANGUAGES = {
	ENGLISH: "en",
	GERMAN: "de",
};

export const PAYMENT_OPTIONS = {
	SAME_AS_DELIVERY_ADDRESS: "same_as_delivery_address",
	POSTAL_ADDRESS: "postal_address",
	EMAIL: "email",
};

export const ORDER_TYPE_OPTIONS = {
	SINGLE: "single",
	SCHEDULE: "schedule",
};

export const TENDER_MODES = {
	PUBLIC: "Public",
	PRIVATE: "Private"
}

// this statuses are used to send to api
export const ORDER_STATUSES = {
	ACTIVE: "active",
	ACCEPT: "accept",
	DELIVERY: "delivery",
	RETOURE: "retoure",
	DRAFT: "draft",
	OPEN: "open",
	DECLINE: "decline",
	CLOSED: "closed",
	ClOSE_REQUESTED: "close_requested",
	DELETED: "deleted"
};

export const TENDER_STATUS = {
	ACTIVE: "active",
	SHIPPED: "shipped",
	DRAFT: "draft",
	PAID: "paid",
	QUOTED: "quoted",
	COMPLETED: "completed",
	LOST: "lost",
	AWARDED: "awarded",
	REJECTED: "rejected",
	EXPIRED: "expired",
	MISSED: "missed"
};

export const EMPTY_TENDER = {}

export const DELETE_TYPE = {
	ALL: "all",
	SELECTED: "selected",
};

export const DOWNLOAD_FIELDS = {
	TENDER_PRODUCTS: [
		"productNumber",
		"nameEN",
		"nameDE",
		"descriptionEN",
		"descriptionDE",
		"categoryShortId",
		"unitEN",
		"unitDE",
		"priceUnit",
		"pricePerPriceUnit",
		"currency",
		"tax",
		"co2",
		"manufacturerId",
		"internalArticleId",
		"volume",
	],
	QUOTATION_COMPARE_PRODUCTS: ["Product"],
};

export const VALID_ATTACHMENT_TYPES = [
	"text/plain",
	"application/msword",
	"img/jpg",
	"img/png",
	"image/jpeg",
	"image/png",
	"image/tiff",
	"application/vnd.openxmlformats-officedocument.wordprocessingml.document",
	"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
	"text/csv",
	"application/pdf",
	"application/acad",
	"image/vnd.dwg",
	"image/x-dwg",
];

export const PRODUCT_DETAILS_SOURCE_TYPE = {
	TENDER: "tender",
	CONTRACT: "contract",
	ORDER: "order",
};

export const MAX_PRODUCT_IMAGES = 7;

export const FILE_TYPES = {
	XLSX: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
	CSV: "text/csv",
	ZIP: "application/zip",
};

export const CURRENCY_ROUND = {
	COMMON: ".2-2",
	DEFAULT_DE: ".2-2",
	DEFAULT_EN: ".2-2",
};

export const COMPARE_QUOTATIONS_EXPORT = {
	HIGHLIGHT_COLOR: "FF00FF00",
	DEFAULT_WIDTH: 20,
};

export const OWNER_ID = {
	BUYER: "017d7e5a-3e45-4158-bf6a-e4c926c3bba9",
	SUPPLIER: "aca3c910-c4a7-49ca-bc4f-b264a75d4b84",
};

export const MAX_FILE_SIZE = 104857600; // 100MB
export const MAX_FILE_SIZE_BY_AI = 5242880; // 5MB
export const MAX_COMMON_FILE_SIZE = 1073741824; // 1GB
export const IMAGE_FILE_SIZE = 1048576;

export const MAX_TENDER_ATTACHMENT_FILE_SIZE = 31457280;
export const MAX_TENDER_EXCEL_IMPORT_FILE_SIZE = 1073741824;
export const IMPORT_STATUS = {
	PENDING: "pending",
	COMPLETED: "completed",
	FAILED: "failed",
	RETRY: "retry",
	INTERVAL: 1000
}

export const IMPORT_PRODUCTS_ERROR = {
	NO_ACTIVE_IMPORTS: "__no_active_imports__",
	IMPORT_PRODUCTS_FAILED: "import_products_failed",
	IMAGE_LIMIT_EXCEEDS: "__image_limit_exceeds__",
	INVALID_FILE_TYPE: "__invalid_file_type__",
	PRODUCT_ALREADY_EXISTS: "__product_already_exists__",
}

export const ADD_UPDATE_PRODUCT = {
	ADD_PRODUCT: "product_create",
	UPDATE_PRODUCT: "product_update"
}

export const RETRY_IMPORT_ERROR = {
	MAXIMAUM_RETRY_REACHED: "__maximum_retry_reached__"
}

export const USER_ROLES = {
	USER_DEACTIVATED: "__user_deactivated__",
	USER_ACTIVATED: "__user_activated__",
	USER_DEACTIVATION_FAILED: "__user_deactivation_failed__",
	USER_ACTIVATION_FAILED: "__user_activation_failed__"
}

export const BEDGES = [
	"#33cc99", // 0
	"#666",	// 1
	"#2496be", // 2
]

